export enum PreWorkupLabConfig {    
    PwlForAllCandidates = 0,
    PwlForNddsAndAdp = 1,
    PwlForNddsOnly = 2,
    PwlForAdpOnly = 3,
    None = 4
}